import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { Patient } from '../../../../core/models/patient/patient';
import {
  PharmacyDetails,
} from '../../../../core/models/patient/pharmacyDetails';
import { CommonService } from '../../../../core/services/v2/common.service';
import { PatientService } from '../../../../core/services/v2/patient.service';
import { UserService } from '../../../../core/services/v2/user.service';
import {
  WindowLoaderService,
} from '../../../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-patient-pharmacy-preferences-edit',
  templateUrl: './patient-pharmacy-preferences-edit.component.html',
  styleUrls: ['./patient-pharmacy-preferences-edit.component.scss']
})
export class PatientPharmacyPreferencesEditComponent implements OnInit {
  @Input() pharmacyPreferences: PharmacyDetails;
  @Input() patientProfile: Patient;
  @Output() patientProfileChange = new EventEmitter<Patient>();
  @Output() toggleEvent = new EventEmitter();
  pharmaciesResult: PharmacyDetails[];
  selectedPharmacies: string[];
  searchField: string;
  zipCode: string;
  userId: number;
  displayResult: any;

  constructor(private patientService: PatientService,
    private userService: UserService,
    private commonService: CommonService,
    private loaderService: WindowLoaderService) { }

  ngOnInit() {

    this.userService.getUserDetails().subscribe(
      (res) => {
        this.userId = res.id;
      },
      (error) => { console.error(error); });

  }

  cancel() {
    this.toggleEvent.emit();
  }

  addPharmacyPreferences() {
    const pharmacies = {
      patientId: this.patientProfile.id,
      npiNumbers: this.selectedPharmacies
    };
    //console.log('param', pharmacies);
    this.loaderService.blockWithLoader(this.patientService.updatePatientPharmacyPreferences(pharmacies)).
      subscribe(
        (result) => {
          if (result.isSuccess) {
            this.loaderService.blockWithLoader(this.patientService.getCurrentPatientDetails()).subscribe(
              (details) => {
                console.log('patphar', details);
                if (details) {
                  this.patientProfile.pharmacy = details.pharmacy;
                  this.patientProfileChange.emit(this.patientProfile);
                }
                this.toggleEvent.emit();
              },
              (error) => { console.error(error); }
            );
          } else {
            console.error(result);
          }
        },
        (error) => {
          console.error(error);
        });
  }

  getPharmacies(value?) {
    let pharmacyName = value
    if(this.zipCode){
    this.loaderService.blockWithLoader(this.commonService.getPharmacyDetails((pharmacyName ? pharmacyName : ''), (this.zipCode ? this.zipCode : ''))).
      subscribe(
        (result) => {
          this.displayResult = result.pharmacyDetails
          this.pharmaciesResult = result.pharmacyDetails;
        },
        (error) => {
          console.error(error);
        });
      }

  }

  getPharmaciesChange(e) {
   if(e.target.value.length ){
    this.getPharmacies(e.target.value)
    console.log(e.target.value);}
    // this.pharmaciesResult = this.displayResult.filter((x:any)=>{ return x.name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1});
  }

  updatePharmacyList(pharmacy: PharmacyDetails) {

      if (!this.selectedPharmacies)
      this.selectedPharmacies = [];

    if (pharmacy.checked) {
      this.selectedPharmacies.push(pharmacy.npi);
    } else {
        this.selectedPharmacies = this.selectedPharmacies.filter(ph => ph != pharmacy.npi);
    }

  }

  isSelected(pharmacy: PharmacyDetails) {
    if (!this.selectedPharmacies || this.selectedPharmacies.length == 0) return false;
    return this.selectedPharmacies.filter(ph => ph == pharmacy.npi).length > 0;
  }
  viewOpeningHour() { }
}
